// src/components/insurance/EmptyState.tsx
import React from 'react';
import { Plus, Shield } from 'lucide-react';

interface EmptyStateProps {
  onAdd: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onAdd }) => (
  <div className="text-center py-12 bg-white rounded-xl shadow-lg">
    <Shield className="w-12 h-12 text-gray-400 mx-auto mb-4" />
    <h3 className="text-lg font-medium text-gray-900 mb-2">No insurance found</h3>
    <p className="text-gray-500 mb-4">Get started by adding your first insurance policy</p>
    <button onClick={onAdd} className="bg-pink-600 text-white py-2 px-4 rounded-lg hover:bg-pink-700 flex items-center mx-auto">
      <Plus className="w-4 h-4 mr-2" />Add Insurance
    </button>
  </div>
);

export default EmptyState;